import type { PathConfig } from '@react-navigation/native';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/password-recovery',
  screens: {
    'forgot-password': '/forgot-password',
    'reset-password': '/reset-password/:email/:code',
  },
};
